import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, inputCls, Logo, Loading } from "@/components/common";
import { Button } from "@/components/ui/button";

export default function Activate() {
  const { token } = useParams();
  const nav = useNavigate();
  const { activate } = useAuth();
  const { data, isLoading, error } = useQuery({ queryKey: ["activate", token], queryFn: () => api.get(`/public/activate/${token}`).then((r) => r.data), retry: false });
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (isLoading) return <Loading full />;
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setErr("Passwords do not match");
    setBusy(true); setErr("");
    try { await activate(token, pw, name || data.user.name); nav("/onboarding"); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#0B192C] grid place-items-center p-4" data-testid="activate-page">
      <div className="w-full max-w-md bg-white rounded-2xl p-6 sm:p-8 fade-up">
        {error || !data ? (
          <div className="text-center" data-testid="activate-invalid"><h1 className="text-2xl font-bold">Invite link not valid</h1><p className="text-sm text-slate-500 mt-2">{errMsg(error)}</p><Button asChild className="btn-orange mt-5"><a href="/login">Go to sign in</a></Button></div>
        ) : (
          <>
            <div className="flex items-center gap-3 mb-6 p-3 rounded-xl bg-slate-50 border"><Logo business={data.business} size={44} /><div><div className="font-display font-bold text-lg leading-tight">{data.business?.business_name}</div><div className="text-xs text-slate-500">{data.business?.plan?.label || "NEEC Service"}</div></div></div>
            <p className="eyebrow">Activate your account</p>
            <h1 className="text-3xl font-bold">Welcome, {data.user.name?.split(" ")[0]}</h1>
            <p className="text-sm text-slate-500 mb-5">Set a password for <strong>{data.user.email}</strong>. Next you will complete a short setup wizard.</p>
            <form onSubmit={submit} className="space-y-4">
              <input type="email" name="username" value={data.user.email || ""} readOnly autoComplete="username" className="hidden" tabIndex={-1} aria-hidden="true" />
              <Field label="Your name"><input className={inputCls} value={name} onChange={(e) => setName(e.target.value)} placeholder={data.user.name} autoComplete="name" data-testid="activate-name-input" /></Field>
              <Field label="Password" hint="At least 8 characters"><input type="password" name="new-password" className={inputCls} value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} autoComplete="new-password" data-testid="activate-password-input" /></Field>
              <Field label="Confirm password"><input type="password" name="confirm-password" className={inputCls} value={pw2} onChange={(e) => setPw2(e.target.value)} required autoComplete="new-password" data-testid="activate-confirm-input" /></Field>
              {err && <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="activate-error">{err}</p>}
              <Button type="submit" disabled={busy} className="w-full h-12 btn-orange text-base" data-testid="activate-submit">{busy ? "Activating..." : "Activate and Continue"}</Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
